/* ============================================
   PRODUCT TITLE — clamp detector + tooltip
   Attaches to any <a data-clamp-target="true">
   (emitted by `product-title-link.liquid`).

   Sets `data-clamped` to `true` / `false` on the
   element after load + on resize. Creates a
   dynamic tooltip element that shows on hover
   when the title is clamped.
   ============================================ */
(function () {
  "use strict";

  /* Several sections each include this script tag; only wire up once. */
  if (window.__lpProductTitleInit) return;
  window.__lpProductTitleInit = true;

  var tooltipEl = null;

  function isClamped(el) {
    return (
      el.scrollWidth > el.clientWidth + 1 ||
      (window.getComputedStyle &&
        (function () {
          var cs = window.getComputedStyle(el);
          if (cs.whiteSpace !== "nowrap") return false;
          return el.scrollWidth > el.clientWidth + 1;
        })())
    );
  }

  function showTooltip(link) {
    var fullTitle = link.getAttribute("data-full-title");
    if (!fullTitle || !isClamped(link)) return;

    if (!tooltipEl) {
      tooltipEl = document.createElement("div");
      tooltipEl.className = "pt-tooltip";
      document.body.appendChild(tooltipEl);
    }

    tooltipEl.textContent = fullTitle;
    tooltipEl.classList.remove("pt-tooltip--below");
    /* Make it laid out so we can measure it, then place + clamp to the
       viewport (cards near the screen edge on mobile otherwise push the
       tooltip off-screen). position: fixed is viewport-relative — do NOT
       add scrollX/scrollY. */
    tooltipEl.classList.add("pt-tooltip--visible");

    var rect = link.getBoundingClientRect();
    var margin = 8;
    var halfW = tooltipEl.offsetWidth / 2;
    var centerX = rect.left + rect.width / 2;
    centerX = Math.max(
      margin + halfW,
      Math.min(window.innerWidth - margin - halfW, centerX)
    );
    tooltipEl.style.left = centerX + "px";

    /* Above the title by default; flip below if it would clip the top. */
    if (rect.top - tooltipEl.offsetHeight - margin < margin) {
      tooltipEl.classList.add("pt-tooltip--below");
      tooltipEl.style.top = rect.bottom + margin + "px";
    } else {
      tooltipEl.style.top = rect.top - margin + "px";
    }
  }

  function hideTooltip() {
    if (tooltipEl) {
      tooltipEl.classList.remove("pt-tooltip--visible");
    }
  }

  function attachTooltipListeners(link) {
    link.addEventListener("mouseenter", function () {
      showTooltip(link);
    });
    link.addEventListener("mouseleave", hideTooltip);
    link.addEventListener("focus", function () {
      showTooltip(link);
    });
    link.addEventListener("blur", hideTooltip);
  }

  function refresh(root) {
    var scope = root || document;
    var links = scope.querySelectorAll('a[data-clamp-target="true"]');
    for (var i = 0; i < links.length; i++) {
      var el = links[i];
      el.setAttribute("data-clamped", isClamped(el) ? "true" : "false");
      if (!el.dataset.tooltipAttached) {
        attachTooltipListeners(el);
        el.dataset.tooltipAttached = "true";
      }
    }
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  function init() {
    refresh();
    window.addEventListener("resize", debounce(refresh, 120));
    /* Fixed-position tooltip doesn't track scroll — just hide it so it
       never freezes mid-air disconnected from the title it belongs to. */
    window.addEventListener("scroll", hideTooltip, { passive: true });
    document.addEventListener("shopify:section:load", function (e) {
      if (e && e.target && e.target.querySelector) refresh(e.target);
    });

    /* Catch cards injected after load with no section:load event —
       e.g. <product-recommendations>, which swaps its HTML in via
       innerHTML once it scrolls into view. */
    if ("MutationObserver" in window && document.body) {
      var rescan = debounce(refresh, 150);
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
            rescan();
            return;
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
